import React from 'react'
import { Link } from 'react-router-dom'

const Schduel = () => {
  return (
    <section className="schedule-section">
    <div className="anim-icons full-width">
      <span className="icon icon-circle-2" />
    </div>
    <div className="auto-container">
      <div className="sec-title text-center">
        <span className="sub-title">Thought leadership</span>
        <h2>
          Join the world's leading companies <br />
          at Technology Conference
        </h2>
        <span className="divider" />
      </div>
      <div className="schedule-tabs tabs-box">
        <div className="btns-box">
          {/*Tabs Box*/}
          <ul className="tab-buttons clearfix">
            <li className="tab-btn active-btn" data-tab="#tab-1">
              <span className="day">1st Day</span>
              <div className="date-box">
                <span className="date">25</span>
                <span className="month">
                  <span className="colored">Jan</span> 2023
                </span>
              </div>
            </li>
            <li className="tab-btn" data-tab="#tab-2">
              <span className="day">2nd Day</span>
              <div className="date-box">
                <span className="date">26</span>
                <span className="month">
                  <span className="colored">Jan</span> 2023
                </span>
              </div>
            </li>
            <li className="tab-btn" data-tab="#tab-3">
              <span className="day">3rd Day</span>
              <div className="date-box">
                <span className="date">27</span>
                <span className="month">
                  <span className="colored">Jan</span> 2023
                </span>
              </div>
            </li>
          </ul>
        </div>
        <div className="tabs-content">
          {/*Tab*/}
          <div className="tab active-tab" id="tab-1">
            <div className="schedule-timeline">
              {/* schedule Block */}
              <div className="schedule-block">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        8.00 AM <br /> 10.00 AM
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-1.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Tripp Mckay</h5>
                      <span className="designation">Historian</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Social Profit from Venture (SROI) Gathering
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
              {/* schedule Block */}
              <div className="schedule-block even">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        10:00 am <br />
                        11:00 am
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-2.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Milana Myles</h5>
                      <span className="designation">Art Critic</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Marine and Oceanic Government Workers
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
              {/* schedule Block */}
              <div className="schedule-block">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        10:00 am <br />
                        11:00 am
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-3.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Gabrielle Winn</h5>
                      <span className="designation">Insurance consultant</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Home Life Open Entryway Open Occasion of 21
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
              {/* schedule Block */}
              <div className="schedule-block even">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        12:00 pm <br />
                        01:00 pm
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-4.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Rene Wells</h5>
                      <span className="designation">Art Critic</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Developing Force Legislative issues of Arctics Motivation
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Tab*/}
          <div className="tab" id="tab-2">
            <div className="schedule-timeline">
              {/* schedule Block */}
              <div className="schedule-block">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        8.00 AM <br /> 10.00 AM
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-1.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Tripp Mckay</h5>
                      <span className="designation">Historian</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Social Profit from Venture (SROI) Gathering
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
              {/* schedule Block */}
              <div className="schedule-block even">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        10:00 am <br />
                        11:00 am
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-2.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Milana Myles</h5>
                      <span className="designation">Art Critic</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Marine and Oceanic Government Workers
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
              {/* schedule Block */}
              <div className="schedule-block">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        10:00 am <br />
                        11:00 am
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-3.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Gabrielle Winn</h5>
                      <span className="designation">Insurance consultant</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Home Life Open Entryway Open Occasion of 21
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
              {/* schedule Block */}
              <div className="schedule-block even">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        12:00 pm <br />
                        01:00 pm
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-4.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Rene Wells</h5>
                      <span className="designation">Art Critic</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Developing Force Legislative issues of Arctics Motivation
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Tab*/}
          <div className="tab" id="tab-3">
            <div className="schedule-timeline">
              {/* schedule Block */}
              <div className="schedule-block">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        8.00 AM <br /> 10.00 AM
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-1.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Tripp Mckay</h5>
                      <span className="designation">Historian</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Social Profit from Venture (SROI) Gathering
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
              {/* schedule Block */}
              <div className="schedule-block even">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        10:00 am <br />
                        11:00 am
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-2.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Milana Myles</h5>
                      <span className="designation">Art Critic</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Marine and Oceanic Government Workers
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
              {/* schedule Block */}
              <div className="schedule-block">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        10:00 am <br />
                        11:00 am
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-3.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Gabrielle Winn</h5>
                      <span className="designation">Insurance consultant</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Home Life Open Entryway Open Occasion of 21
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
              {/* schedule Block */}
              <div className="schedule-block even">
                <div className="inner-box">
                  <div className="inner">
                    <div className="date">
                      <span>
                        12:00 pm <br />
                        01:00 pm
                      </span>
                    </div>
                    <div className="speaker-info">
                      <figure className="thumb">
                        <img src="images/resource/thumb-4.jpg" alt="" />
                      </figure>
                      <span className="icon fa fa-microphone" />
                      <h5 className="name">Rene Wells</h5>
                      <span className="designation">Art Critic</span>
                    </div>
                    <h4>
                      <Link  to="schedule-detail.html">
                        Developing Force Legislative issues of Arctics Motivation
                      </Link> 
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default Schduel